export const penaltyText = {
  addPenalty: 'Добавить просрочку по займу',
  penalty: 'Просрочка по займу',
};
